import Vue from 'vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { MtButton } from '../MtButton';
import { MtCenterBlock } from '../MtCenterBlock';
import { MtIcon } from '../MtIcon';
import './MtModal.css';
import '../MtIcon/svg/close.svg';
export default Vue.extend({
    name: 'MtModal',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        transition: {
            type: String,
            default: 'mt-modal-transition',
        },
        topIndent: {
            type: [HTMLElement, Object, Function, Number],
            default: 48,
        },
    },
    methods: {
        onTransitionBeforeEnter: function (el) {
            var topIndent = this.getTopIndent();
            this.$refs.body.style.top =
                (topIndent || 0) + 'px';
            this.$emit('before-enter', el);
        },
        onTransitionEnter: function (el) {
            disableBodyScroll(this.$refs.body);
            this.$emit('enter', el);
        },
        onTransitionAfterEnter: function (el) {
            this.$emit('after-enter', el);
        },
        onTransitionEnterCancelled: function (el) {
            this.$emit('enter-cancelled', el);
        },
        onTransitionBeforeLeave: function (el) {
            enableBodyScroll(this.$refs.body);
            this.$emit('before-leave', el);
        },
        onTransitionLeave: function (el) {
            this.$emit('leave', el);
        },
        onTransitionAfterLeave: function (el) {
            this.$emit('after-leave', el);
        },
        onTransitionLeaveCancelled: function (el) {
            this.$emit('leave-cancelled', el);
        },
        getTopIndent: function () {
            var topIndent = this.$props.topIndent;
            // HTMLElement
            if (topIndent instanceof HTMLElement) {
                return topIndent.clientHeight;
            }
            // Vue
            else if (typeof topIndent === 'object' &&
                topIndent != null &&
                topIndent.hasOwnProperty('$el')) {
                return topIndent.$el.clientHeight;
            }
            // Function
            else if (typeof topIndent === 'function') {
                return topIndent();
            }
            // Number
            else {
                return topIndent;
            }
        },
    },
    render: function (h) {
        var _this = this;
        return h('transition', {
            props: {
                name: this.transition,
            },
            on: {
                beforeEnter: this.onTransitionBeforeEnter,
                enter: this.onTransitionEnter,
                afterEnter: this.onTransitionAfterEnter,
                enterCancelled: this.onTransitionEnterCancelled,
                beforeLeave: this.onTransitionBeforeLeave,
                leave: this.onTransitionLeave,
                afterLeave: this.onTransitionAfterLeave,
                leaveCancelled: this.onTransitionLeaveCancelled,
            },
        }, [
            this.visible
                ? h('div', {
                    ref: 'modal',
                    staticClass: 'mt-modal',
                    on: {
                        click: function () {
                            _this.$emit('update:visible', false);
                        },
                    },
                }, [
                    h('div', {
                        staticClass: 'mt-modal__body',
                        ref: 'body',
                        on: {
                            click: function (e) {
                                e.stopPropagation();
                            },
                        },
                    }, [
                        h(MtCenterBlock, {
                            staticClass: 'mt-modal__top',
                        }, [
                            h(MtButton, {
                                staticClass: 'mt-modal__close',
                                on: {
                                    click: function () {
                                        _this.$emit('update:visible', false);
                                    },
                                },
                            }, [
                                h(MtIcon, {
                                    props: {
                                        glyph: 'close',
                                        width: '16',
                                        height: '16',
                                    },
                                }),
                            ]),
                        ]),
                        h(MtCenterBlock, {
                            staticClass: 'mt-modal__content',
                        }, [this.$slots.default]),
                    ]),
                ])
                : null,
        ]);
    },
});
//# sourceMappingURL=MtModal.js.map